import moment from "moment";
import { getLabel, getLabelWithType, getTagStyle, getTypeLabel } from "../config";
// 时间转换
const changeTime = (string) => {
  // 时间字符传 2019/10/01T12:00:00+08:00(后面时区固定为+08:00)
  let time = moment(string).format();
  let newTime = time.slice(0, 19) + "+08:00";
  //let newTime = moment(string).format('YYYY-MM-DD h:mm:ss')
  // 时间戳
  //let time = new Date(string)
  //let newTime = Date.parse(time) / 1000
  return newTime;
};

export const changeDate = (time) => {
  if (!time || time === "未知") {
    return "-";
  }
  let date = moment
    .utc(time)
  if (date.valueOf() <= 0) return '-'
  return date.utcOffset(480)
    .format("YYYY-MM-DD HH:mm:ss");;
};
const changeMd = (time) => {
  if (!time || time === "未知") {
    return "未知";
  }
  let date = moment
    .utc(time)
    .utcOffset(480)
    .format("YYYY-MM-DD");
  return date;
};
// number 千位分隔符
const numFormat = (num) => {
  num = num.toString().split("."); // 分隔小数点
  var arr = num[0].split("").reverse(); // 转换成字符数组并且倒序排列
  var res = [];
  for (var i = 0, len = arr.length; i < len; i++) {
    if (i % 3 === 0 && i !== 0) {
      res.push(","); // 添加分隔符
    }
    res.push(arr[i]);
  }
  res.reverse(); // 再次倒序成为正确的顺序
  if (num[1]) {
    // 如果有小数的话添加小数部分
    res = res.join("").concat("." + num[1]);
  } else {
    res = res.join("");
  }
  return res;
};
/***
 * 保留两位小数且四舍五入
 * ***/
const iTofixed = (num) => {
  return (
    Math.round(num * Math.pow(10, 2)) / Math.pow(10, 2) +
    Math.pow(10, -(2 + 1))
  )
    .toString()
    .slice(0, -1);
};
// 支付方式过滤条件
const payTypeRule = (value) => {
  let payMethods = {
    alipay: "支付宝",
    wechat: "微信",
    union: "银联",
    daichong: "代充",
    bankcard: "银行卡",
    usdt: "USDT"
  };
  return payMethods[value] ? payMethods[value] : "未知";
};

// 审核过滤条件
const commentStatus = (status) => {
  switch (status) {
    case 1:
      return "审核通过";
    case 2:
      return "未审核";
    case 3:
      return "自动过滤";
  }
};
// 订单审核过滤
const orderStatus = (status) => {
  switch (status) {
    case 1:
      return "进行中";
    case 2:
      return "付款失败";
    case 3:
      return "付款成功";
    case 4:
      return "已退款";
  }
};
// 提现订单状态
const withdrawStatus = (status) => {
  switch (status) {
    case 1:
      return "未审核";
    case 2:
      return "转账中";
    case 3:
      return "已拒绝";
    case 4:
      return "未知错误";
    case 5:
      return "提现成功";
    case 6:
      return "提现失败";
  }
};
// 活动状态过滤
const activeStatus = (status) => {
  switch (status) {
    case "ready":
      return "准备中";
    case "processing":
      return "进行中";
    case "finished":
      return "已完成";
  }
};
// 活动状态过滤
const messTypeStatus = (status) => {
  switch (status) {
    case "REGULAR_NOTICE_TYPE":
      return "定时通知";
    case "PLAN_NOTICE_TYPE":
      return "计划通知";
    case "SPECIFY_NOTICE_TYPE":
      return "规定通知";
    case "AFTER_REGIST_NOTICE":
      return "注册后通知";
  }
};
const senderStatus = (status) => {
  switch (status) {
    case "SYSTEM":
      return "system 系统消息";
    case "ACTASST":
      return "ActAsst 活动助手";
  }
};
const reStatus = (status) => {
  switch (status) {
    case "ALL_USER":
      return "所有用户";
    case "SOME_USER":
      return "部分用户";
  }
};

// 自动账单状态
const automaticStatus = (status) => {
  switch (status) {
    case 0:
      return "未审核";
    case 1:
      return "通过审核";
    case 2:
      return "已拒绝";
    case 3:
      return "付款成功";
    case 4:
      return "付款失败";
  }
};
// 兑换码类型
const Type = (status) => {
  switch (status) {
    case 1:
      return "增加vip天数";
    case 2:
      return "增加金币";
  }
};

// 将秒转换为时分秒
const changeSecond = (ms) => {
  let hour = Math.floor(ms / 3600);
  let min = Math.floor((ms % 3600) / 60);
  let second = Math.floor((ms % 3600) % 60);
  hour = hour > 0 ? (hour <= 9 ? "0" + hour : hour) : "00";
  min = min > 0 ? (min <= 9 ? "0" + min : min) : "00";
  second = second > 0 ? (second <= 9 ? "0" + second : second) : "00";
  return hour + ":" + min + ":" + second;
};
// 保留两位小数并转化为百分比显示
const transformNumber = (init) => {
  return `${(100 * Number(init)).toFixed(2)}%`;
};

// 保留两位小数
const transformFloat = (init) => {
  return `${Number(init).toFixed(2)}`;
};
//保留两位小数
const fixed2 = (x) => {
  return Number.parseFloat(x).toFixed(2);
};
// 数据为空或者0 处理
const floatRule = (value) => {
  if (value && value > 0) {
    return value;
  } else {
    return 0;
  }
};
// 数据为空或者0 处理（率）
const percentRule = (value) => {
  if (value && value > 0) {
    return `${(100 * Number(value)).toFixed(2)}%`;
  } else {
    return "0.00%";
  }
};
// num不足n位，前面加0
export const prefixZero = (num, n = 2) => {
  return (Array(n).join('0') + num).slice(-n)
}

// 数组转化成字符串
const amountTypesFun = (val) => {
  if (val instanceof Array) {
    return val.map((v) => v / 100).join(",");
  }
  return val;
};

// 报告类型
const peportTypeRule = (peportType) => {
  switch (peportType) {
    case 0:
      return "本月注册";
    case 1:
      return "日均活跃";
    case 2:
      return "本月业绩";
    case 3:
      return "日均";
    case 4:
      return "累计日均";
  }
};
const trsndferStatus = (status) => {
  switch (status) {
    case 0:
      return "未知";
    case 1:
      return "转账中";
    case 2:
      return "转账成功";
    case 3:
      return "转账失败";
  }
};
const videoStatus = (status) => {
  let statusDesc = {
    Merging: "合并中",
    MergeCompleted: "合并完成",
    MergeError: "合并失败",
    Converting: "格式转换中",
    ConvertError: "转换失败",
    UpLoading: "正在上传中",
    Completed: "完成",
  };
  return statusDesc[status] ? statusDesc[status] : "未知";
};
//  审核状态
const reviewStatusFun = (value) => {
  switch (value) {
    case 0:
      return "审核中";
    case 1:
      return "通过";
    case 2:
      return "拒绝";
  }
};
//  广告链接类型
const hrefTypeFun = (value) => {
  switch (value) {
    case 0:
      return "外部浏览器跳转";
    case 1:
      return "内部浏览器跳转";
    case 2:
      return "APP内部跳转";
  }
};

//  广告位置
const positionFun = (value) => {
  switch (value) {
    case 0:
      return "启动页广告";
    case 1:
      return "首页-推荐小广告";
    case 2:
      return "首页-弹窗公告";
    case 3:
      return "消息-界面广告";
    case 4:
      return "撩吧-轮播广告";
    case 5:
      return "钱包-轮播广告";
  }
};

//  税率等级
const taxLevelList = (value) => {
  switch (value) {
    case 0:
      return "70%";
    case 6:
      return "60%";
    case 5:
      return "50%";
    default:
      return "70%";
  }
};
//  税率等级
const soldOutType = (value) => {
  switch (value) {
    case true:
      return "买断";
    case false:
      return "未买断";
  }
};
//  商人类型
const businessType = (value) => {
  switch (value) {
    case 1:
      return "聚商";
    case 2:
      return "普通商人";
  }
};
// 模版样式（落地页配置）
const styleList = (value) => {
  switch (value) {
    case "switchStress":
      return "突出";
    case "switchSimple":
      return "简单";
  }
};
// 模版类型（落地页配置）
const typeList = (value) => {
  switch (value) {
    case "iosEnterprise":
      return "ios企业包开关";
    case "iosStore":
      return "ios商店包开关";
    case "android":
      return "安卓开关";
  }
};
//产品类型（VIP商品列表）
const productTypeList = (value) => {
  switch (value) {
    case 0:
      return "会员卡";
    case 3:
      return "约会卡";
    case 5:
      return "新手卡";
    case 6:
      return "实体商品";
    case 10:
      return "楼凤全免卡";
    case 20:
      return "其它卡";
    case 21:
      return "预售卡";
    case 24:
      return "白嫖卡";
  }
};

//展示样式（产品位置配置）
const showTypeList = (value) => {
  switch (value) {
    case 1:
      return "横";
    case 2:
      return "竖";
  }
};

//处理状态（举报信息列表）
const processingStatusList = (value) => {
  switch (value) {
    case 0:
      return "等待处理";
    case 1:
      return "处理完成";
    case 2:
      return "忽略";
  }
};
//举报类型（举报信息列表）
const feedbackTypeList = (value) => {
  switch (value) {
    case 1:
      return "无效联系方式";
    case 2:
      return "骗子";
    case 3:
      return "重复信息";
  }
};
// 置顶类型（嫩模信息列表）
const topLevels = (value) => {
  switch (value) {
    case 20:
      return "全局置顶";
    case 10:
      return "城市置顶";
    case 9:
      return "城市次级置顶";
    // case 0:
    //   return '非置顶'
  }
};

// 收听权限（有声小说列表）
const listenPermissions = (value) => {
  switch (value) {
    case 0:
      return "会员";
    case 1:
      return "金币购买";
    case 3:
      return "试听";
  }
};
//特权（VIP商品列表）
const privileges = (status) => {
  switch (status) {
    case 1:
      return "专属高清线路";
    case 2:
      return "私信随意聊";
    case 3:
      return "优质资源";
    case 4:
      return "帖子优先审核";
    case 5:
      return "评论区霸主";
    case 6:
      return "视频无限观看";
    case 7:
      return "专属客服";
    case 8:
      return "修改个人头像";
    case 9:
      return "修改个性签名";
    case 10:
      return "浏览小说";
    case 11:
      return "畅听有声小说";
  }
};
export default {
  changeDate,
  numFormat,
  commentStatus,
  orderStatus,
  changeSecond,
  transformNumber,
  transformFloat,
  payTypeRule,
  withdrawStatus,
  activeStatus,
  floatRule,
  percentRule,
  messTypeStatus,
  senderStatus,
  reStatus,
  automaticStatus,
  Type,
  amountTypesFun,
  peportTypeRule,
  changeMd,
  trsndferStatus,
  videoStatus,
  reviewStatusFun,
  hrefTypeFun,
  positionFun,
  taxLevelList,
  soldOutType,
  changeTime,
  businessType,
  styleList,
  typeList,
  productTypeList,
  iTofixed,
  fixed2,
  showTypeList,
  processingStatusList,
  feedbackTypeList,
  topLevels,
  listenPermissions,
  privileges,
  getTagStyle,
  getLabel,
  getTypeLabel,
  getLabelWithType,
  prefixZero
};
